import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function extractData(payload) {
  return payload?.data ?? payload;
}

const expenseMasterService = {
  async createExpense(values) {
    try {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (values[key] !== null && values[key] !== undefined) {
          formData.append(key, values[key]);
        }
      });
      const response = await apiClient.post("/expense-master", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getExpensesByBL(blId) {
    try {
      const response = await apiClient.get(`/expense-master/bl/${blId}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteExpense(id) {
    try {
      const response = await apiClient.delete(`/expense-master/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default expenseMasterService;
